import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { IconComponent, SearchInputComponent } from '@mode/capra';
import { DatasetsFacade } from '@mode/dataset/domain';

import { DatasetBrowserData, DatasetTabType, BrowserDatasetTabData } from '@mode/shared/contract-common';

import { DatasetSearchDataTableComponent } from '../dataset-search-data-table/dataset-search-data-table.component';

@Component({
  selector: 'mode-dataset-search-tab-content',
  standalone: true,
  imports: [CommonModule, IconComponent, ReactiveFormsModule, DatasetSearchDataTableComponent, SearchInputComponent],
  templateUrl: './dataset-search-tab-content.component.html',
  styleUrls: ['./dataset-search-tab-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatasetSearchTabContentComponent {
  @Input() datasetTabType: DatasetTabType = DatasetTabType.Workspace;
  @Input()
  dataSourceTabContent: BrowserDatasetTabData = {
    dataSources: [],
    pagination: {
      page: 0,
      per_page: 0,
      count: 0,
      total_pages: 0,
      total_count: 0,
    },
    searchEmptyState: false,
    searchTerm: '',
    isLoading: true,
    displayedColumns: ['name', 'description', 'collection', 'creator', 'lastRefreshed'],
  };

  @Output() selectDataset = new EventEmitter<DatasetBrowserData>();
  @Output() changeCurrentPage = new EventEmitter<number>();
  @Output() searchTermChange = new EventEmitter<string>();
  readonly NO_SEARCH_RESULTS_WORKSPACE =
    'Make sure the spelling is correct and the data you’re searching for has been moved to a Workspace Collection';
  readonly NO_SEARCH_RESULTS_PERSONAL =
    'Make sure the spelling is correct and the data you’re searching for is in your Personal content';

  constructor(public datasetsFacade: DatasetsFacade) {}

  selectedDataset(element: DatasetBrowserData) {
    this.selectDataset.emit(element);
  }

  filterResults(searchTerm: string) {
    this.datasetTabType === 'workspace'
      ? this.datasetsFacade.updateWorkspaceSearchTerm(searchTerm)
      : this.datasetsFacade.updatePersonalSearchTerm(searchTerm);

    this.searchTermChange.emit(searchTerm);
  }

  handleChangeCurrentPage(pageNum: number) {
    this.changeCurrentPage.emit(pageNum);
  }
}
